<template>
  <div ref="svg" style="position: relative;" v-bind:class="['root', 'pop-pyr-chart', {'col_1_2': expanded || $mq === 'sm' || printing}]">
    <h5>Population by Age</h5>
    <div class="mapboxgl-ctrl-top-right">
      <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
        <button
          v-bind:class="['mapboxgl-ctrl-icon', {'mapboxgl-ctrl-shrink': expanded, 'mapboxgl-ctrl-fullscreen': !expanded}]"
          v-on:click="expanded = !expanded"
        ><span class="mapboxgl-ctrl-icon" aria-hidden="true"></span></button>
      </div>
    </div>
    <svg
      v-bind:viewBox='"0,0,"+(width + margin.left + margin.right)+","+(height + margin.top + margin.bottom)'
    >
      <defs>
        <linearGradient id="gradF" x1="100%" y1="0%" x2="0%" y2="0%">
          <stop offset="0%" style="stop-color:#6f978d;stop-opacity:.1"/>
          <stop offset="100%" style="stop-color:#6f978d;stop-opacity:.9"/>
        </linearGradient>
        <linearGradient id="gradM" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#6f978d;stop-opacity:.1"/>
          <stop offset="100%" style="stop-color:#6f978d;stop-opacity:.9"/>
        </linearGradient>
      </defs>
      <g v-bind:transform="'translate(' + margin.left + ',' + margin.top + ')'">
        <g v-bind:transform="'translate(' + fXOrigin + ',0)'">
          <text text-anchor="middle" v-bind:x="-yAxisWidth/2" y="-2">Age</text>
          <text text-anchor="end" v-bind:x="mXOrigin">Women</text>
          <yAxis v-bind:scale="yScaleLinear" v-bind:axisWidth="-1" v-bind:tickValues="[0, 10, 20, 30, 40, 50, 60, 70, 80]"/>
          <xAxis v-bind:scale="xScale" v-bind:transform="'translate(-1,'+height+')'"/>
          <g
            v-for="ind in ageDataFemale"
            v-bind:key="ind.name"
            v-tooltip="{
                        content: '<div>' + getIndName(ind.name) + '</div><div>' + tooltipFormat(ind) + '</div>',
                        classes: ['d3-tip'],
                        container: $refs.svg,
                        placement: 'top',
                        boundariesElement: $refs.svg,
                      }"
            fill-opacity="0.8"
          >
            <!--this is used for coloring the moe-->
            <rect
              v-if="ind.moe !== 0"
              v-bind:class="['moe']"
              v-bind:height="yScaleBand.bandwidth()"
              v-bind:x="xScale(Math.max(ind.value - ind.moe, 0))"
              v-bind:y="yScaleBand(getIndShortName(ind.name))"
              v-bind:width="xScale(ind.value + ind.moe) - xScale(Math.max(ind.value - ind.moe, 0))"
              fill="url(#gradF)"
            ></rect>
            <!--this is used for coloring the value-->
            <line
              v-if="ind.moe !== 0"
              v-bind:y1="yScaleBand(getIndShortName(ind.name))"
              v-bind:y2="yScaleBand(getIndShortName(ind.name)) + yScaleBand.bandwidth()"
              v-bind:x1="xScale(ind.value)"
              v-bind:x2="xScale(ind.value)"
              stroke="#D32704"
            ></line>
            <rect
              v-bind:class="['bar']"
              v-bind:height="yScaleBand.bandwidth()"
              v-bind:y="yScaleBand(getIndShortName(ind.name))"
              v-bind:x="0"
              v-bind:width="xScale(Math.max(ind.value - ind.moe, 0))"
            ></rect>
            <!--this is used for hover effects not having gaps between bars-->
            <rect
              v-bind:class="['transparent']"
              v-bind:height="yScaleBand.step()"
              v-bind:y="yScaleBand(getIndShortName(ind.name)) - ((yScaleBand.step() - yScaleBand.bandwidth()) / 2)"
              v-bind:x="-5"
              v-bind:width="xScale(ind.value + ind.moe) + 5"
            ></rect>
          </g>
        </g>

        <text>Men</text>
        <yAxis v-bind:scale="yScaleLinear" v-bind:orient="'right'" v-bind:axisWidth="mXOrigin" v-bind:format="''"/>
        <xAxis v-bind:scale="mXScale" v-bind:transform="'translate(0,'+height+')'"/>
        <g
            v-for="ind in ageDataMale"
            v-bind:key="ind.name"
            v-tooltip="{
                        content: '<div>' + getIndName(ind.name) + '</div><div>' + tooltipFormat(ind) + '</div>',
                        classes: ['d3-tip'],
                        container: $refs.svg,
                        placement: 'top',
                        boundariesElement: $refs.svg,
                      }"
            fill-opacity="0.8"
          >
            <!--this is used for coloring the moe-->
            <rect
              v-if="ind.moe !== 0"
              v-bind:class="['moe']"
              v-bind:height="yScaleBand.bandwidth()"
              v-bind:x="mXScale(ind.value + ind.moe)"
              v-bind:y="yScaleBand(getIndShortName(ind.name))"
              v-bind:width="xScale(ind.value + ind.moe) - xScale(Math.max(ind.value - ind.moe, 0))"
              fill="url(#gradM)"
            ></rect>
            <!--this is used for coloring the value-->
            <line
              v-if="ind.moe !== 0"
              v-bind:y1="yScaleBand(getIndShortName(ind.name))"
              v-bind:y2="yScaleBand(getIndShortName(ind.name)) + yScaleBand.bandwidth()"
              v-bind:x1="mXScale(ind.value)"
              v-bind:x2="mXScale(ind.value)"
              stroke="#D32704"
            ></line>
            <rect
              v-bind:class="['bar']"
              v-bind:height="yScaleBand.bandwidth()"
              v-bind:y="yScaleBand(getIndShortName(ind.name))"
              v-bind:x="mXScale(Math.max(ind.value - ind.moe, 0))"
              v-bind:width="xScale(Math.max(ind.value - ind.moe, 0))"
            ></rect>
            <!--this is used for hover effects not having gaps between bars-->
            <rect
              v-bind:class="['transparent']"
              v-bind:height="yScaleBand.step()"
              v-bind:y="yScaleBand(getIndShortName(ind.name)) - ((yScaleBand.step() - yScaleBand.bandwidth()) / 2)"
              v-bind:x="mXScale(ind.value + ind.moe) - 5"
              v-bind:width="xScale(ind.value + ind.moe) + 5"
            ></rect>
          </g>
      </g>
    </svg>
  </div>
</template>
<script>
import yAxis from './yAxis.vue'
import xAxis from './xAxis.vue'
import * as d3 from 'd3'

export default {
  name: 'PopPyramidChart',
  components: { yAxis, xAxis },
  props: [ 'ageDataFemale', 'ageDataMale', 'getIndName', 'printing'],
  data: function () {
    return {
      margin: { top: 20, right: 10, bottom: 20, left: 10 },
      width: 500,
      height: 150,
      yAxisWidth: 30,
      expanded: false,
    }
  },
  methods: {
    getIndShortName: function (ind) {
      return this.getIndName(ind).replace(/^(Fem|M)ale Population Age /, '')
    },
    format: d3.format(',d'),
    tooltipFormat: function (ind) {
      if (ind.moe === 0) {
        return '<strong>' + this.format(ind.value) + '</strong>'
      } else {
        return '<strong>' + this.format(ind.value) + '</strong><small>  +/- ' + this.format(ind.moe) + '</small>'
      }
    },
  },
  computed: {
    mXOrigin: function () {
      return (this.width - this.yAxisWidth) / 2
    },
    fXOrigin: function () {
      return this.mXOrigin + this.yAxisWidth
    },
    xScale: function () {
      let mx = d3.scaleLinear().range([0, this.mXOrigin])
      if (this.ageDataMale) {
        mx.domain([0, d3.max(this.ageDataMale.concat(this.ageDataFemale), d => (d.value + d.moe))])
      }
      return mx
    },
    mXScale: function () {
      let mx = d3.scaleLinear().range([0, this.mXOrigin])
      if (this.ageDataMale) {
        mx.domain([d3.max(this.ageDataMale.concat(this.ageDataFemale), d => (d.value + d.moe)), 0])
      }
      return mx
    },
    yScaleBand: function () {
      let y = d3.scaleBand().padding(0.25).range([this.height, 0])
      y.domain(this.ageDataMale.map(d => this.getIndShortName(d.name)))
      return y
    },
    yScaleLinear: function () {
      let y = d3.scaleLinear().range([this.height, 0])
      y.domain([0, 90])
      return y
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only. /deep/ applies to children as well -->
<style scoped>
  .root {
    position: relative;
    background: white;
    padding: 5px;
    margin: 9px;
    border-radius: 5px;
    border-color: #cbc7c7;
    border-width: 1px;
    border-style: solid;
    box-shadow: 10px 20px 17px -8px #cbc7c7;
  }

  svg {
    width: 100%;
  }

  h2, h3, h4, h5, h6 {
    margin: 0;
  }

  .bar {
    fill: #6f978d;
  }

  .transparent {
    opacity: 0;
  }

  .hover-bar {
    fill: #22323b;
    opacity: 1;
  }

  .selected-bar {
    fill: #418cff;
    opacity: 1;
  }

  @media (max-width: 576px), print {
    .mapboxgl-ctrl-icon {
      display: none;
    }
  }
</style>
